import React, { useEffect, useState } from 'react';
import HTMLReactParser from 'html-react-parser';

// Components
import VideoPlayer from "../components/VideoPlayer";
import service from "../common/service"

// Slick Slider - Package
import Slider from "react-slick";
import Loader from './Loader';

// Header slider Configuration
const sliderConfig = {
    dots: true,
    infinite: false,
    arrows: false,
    slidesToShow: 1,
    slidesToScroll: 1,
}
let sub;
function Tab(props) {
    const { selectTab, festInfo, setFestInfo,isTabLoading } = props
    const [apiServe, ] = useState(new service());
    // const [loader, setLoader] = useState(false)

    useEffect(() => {

        sub = apiServe.getevent().subscribe((response) => {
            switch (response.event) {
                case "howToFestOnline|ticketsRedemptions|getDetail":
                    
                    
                    if (response.error) {
                        // console.log(response.error)
                    }
                    else {
                        props.stopLoader();
                        setFestInfo(response.data)
                    }
                    break;
                case "howToFestOnline|howToWatch|getDetail":
                    if (response.error) {
                        // console.log(response.error)
                    }
                    else {
                        props.stopLoader();
                        setFestInfo(response.data)
                    }
                    break;
                case "howToFestOnline|checkYourTech|getDetail":
                    
                    if (response.error) {
                        // console.log(response.error)
                    }
                    else {
                        props.stopLoader();
                        setFestInfo(response.data)
                    }
                    break;
                case "howToFestOnline|accessibility|getDetail":
                    ;
                    if (response.error) {
                        console.log(response.error)
                    }
                    else {
                        props.stopLoader();
                        setFestInfo(response.data)
                        // console.log("responsedata",response.data);
                    }
                    break;
                case "howToFestOnline|healthWellness|getDetail":
                    
                    if (response.error) {
                        // console.log(response.error)
                    }
                    else {
                        props.stopLoader();
                        setFestInfo(response.data)
                    }
                    break;
                case "howToFestOnline|safetyBelonging|getDetail":
                    
                    if (response.error) {
                        // console.log(response.error)
                    }
                    else {
                        props.stopLoader();
                        setFestInfo(response.data)
                    }
                    break;
                case "howToFestOnline|moreInfo|getDetail":
                    
                    if (response.error) {
                        // console.log(response.error)
                    }
                    else {
                        props.stopLoader();
                        setFestInfo(response.data)
                    }
                    break;
                default:
                    break;
            }
        });
        // getTabInfo();
        // setLoader(false)
        return () => {
            sub.unsubscribe()
        }
    }, [selectTab])

    //call event
    // const getTabInfo = () => {
    //     if (selectTab === 0) {
    //         setLoader(true);
    //         apiServe.sendevent("howToFestOnline|ticketsRedemptions|getDetail", {})
    //     } else if (selectTab === 1) {
    //         setLoader(true);
    //         apiServe.sendevent("howToFestOnline|howToWatch|getDetail", {})
    //     } else if (selectTab === 2) {
    //         setLoader(true);
    //         apiServe.sendevent("howToFestOnline|checkYourTech|getDetail", {})
    //     } else if (selectTab === 3) {
    //         setLoader(true);
    //         apiServe.sendevent("howToFestOnline|accessibility|getDetail", {})
    //     } else if (selectTab === 4) {
    //         setLoader(true);
    //         apiServe.sendevent("howToFestOnline|healthWellness|getDetail", {})
    //     } else if (selectTab === 5) {
    //         setLoader(true);
    //         apiServe.sendevent("howToFestOnline|safetyBelonging|getDetail", {})
    //     } else if (selectTab === 6) {
    //         setLoader(true);
    //         apiServe.sendevent("howToFestOnline|moreInfo|getDetail", {})
    //     }
    // }
    return (
        <>
            {isTabLoading && <Loader />}
            {Object.keys(festInfo).length !== 0 &&

                <div className="sd_home_desc_sec">
                    <div className="sd_inner_container ">
                        <div className="sd_home_desc_wpr">

                            <div className="sd_home_fest_wpr sd_video_wpr">
                                <div className="sd_home_fest_desc">
                                    <h2>{festInfo.title}</h2>
                                    <div className="sd_rtf_content">
                                        {HTMLReactParser(festInfo.paragraph)}
                                    </div>
                                </div>
                                {festInfo.media.length &&
                                    <Slider className="sd_home_fest_slider" {...sliderConfig}>
                                        {festInfo && festInfo.media && festInfo.media.filter(data => (data.inSite !== '' || data.link !== '')).map((item, index) => {
                                            return (
                                                item.inSite
                                                    ? item.inSite.toLowerCase().match(/\.(jpeg|jpg|gif|png|jfif)$/) != null
                                                        ? <div className="sd_home_fest_slider_block" key={index}>
                                                            <img src={item.inSite.includes('http')
                                                                ? item.inSite
                                                                : apiServe.imageUrl + item.inSite}
                                                                alt="Fest Title" title="Fest Title"
                                                            />
                                                        </div>
                                                        : <div className="sd_home_fest_slider_block sd_video_wpr" key={index}>
                                                            <VideoPlayer
                                                                videoSrc={item.inSite.includes('http') ? item.inSite : apiServe.imageUrl + item.inSite}
                                                                autoplay={false}
                                                                loop={true}
                                                            />
                                                        </div>
                                                    : item.link.toLowerCase().match(/\.(jpeg|jpg|gif|png|jfif)$/) != null
                                                        ? <div className="sd_home_fest_slider_block" key={index}>
                                                            <img src={item.link} alt="Fest Title" title="Fest Title" />
                                                        </div>
                                                        :
                                                        // <div className="sd_home_fest_slider_block sd_video_wpr" key={index}>
                                                        //     <VideoPlayer
                                                        //         videoSrc={item.link} 
                                                        //         autoplay={false}
                                                        //         loop={true}
                                                        //     />
                                                        // </div>
                                                        <div className="iframeContainer sd_home_fest_slider_block sd_video_wpr" key={index}>
                                                            {isTabLoading ? <Loader /> : <iframe
                                                                src={
                                                                      item.link && item.link +
                                                                    "?enablejsapi=1&version=3&playerapiid=ytplayer"
                                                                }
                                                            ></iframe>}
                                                        </div>
                                            )
                                        })}
                                    </Slider>

                                }
                            </div>

                            <div className="sd_home_fest_details sd_rtf_content">
                                {HTMLReactParser(festInfo.body)}
                            </div>
                        </div>

                    </div>
                </div>
            }
        </>
    )
}

export default Tab;